import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import i18n from './i18n';
import apolloProvider from './apollo.js';
import 'animate.css';
import '@/assets/styles/main.sass';
import NotFoundView from '@/views/NotFoundView.vue';

const app = createApp(App);

app.use(i18n).use(store).use(router).use(apolloProvider).component('not-found-view', NotFoundView);

app.mount('#app');
